import React from 'react';

export const BioPage = () => {
  return (
    <div className='bg-primary'>
    <div className="flex flex-row items-center justify-between bg-black mt-[-10px]">
      {/* Left Div */}
      <div className="flex-1 h-full bg-black">
        <h1 className='text-primary text-2xl font-bold text-center'>BIOGRAPHY</h1>
        <p className='text-white text-[10px] p-[12px] '>Chima Udoye, a Nigerian vocalist renowned for his jazz and soul music, gained national acclaim after winning Nigerian Idol Season 9 in July 2024.His journey to stardom is marked by a deep-seated passion for music and acommitment to inspiring others through his art.</p>


      </div>

      {/* Right Div */}
      <div className="flex-1 flex justify-center items-center h-full">
        <img className="object-cover w-full h-[240px]" src="Images/speaker.png" alt="Speaker" />
      </div>
    </div>
    <div className='bg-primary'>
    <p className='text-white text-[15px] text-center'>Early Life and Musical Beginnings</p>
    <p className='text-white text-[12px] p-[14px] '>Born and raised in Warri, Delta State, Nigeria, Chima's upbringing wassteeped in the rich cultural heritage of his homeland. From an early age, heexhibited a profound love for music, drawing inspiration from both traditional Nigerian sounds and global genres. This eclectic musical foundation led him to specialize in jazz and soul, genres that allowed him to express hisunique artistic vision</p>
    

    <p className='text-white text-[15px] text-center mt-4'>Nigerian Idol Journey</p>
    <p className='text-white text-[12px] p-[14px]'>Chima's participation in Nigerian Idol Season 9 was a defining chapter in his career. Throughout the competition, he captivated audiences and judges alike with his charismatic stage presence and vocal prowess. His performances were consistently praised for their emotional depth and technical excellence, setting him apart as a formidable contestant. JudgeOmawumi notably remarked that Chima seemed to be "in competition with himself," highlighting his exceptional talent. The grand finale, held on July 14, 2024, was a testament to Chima's artistry. He delivered a powerful rendition of John Legend's "Glory" alongside the top 10 contestants, a performance that resonated deeply with viewers as well as stunning them with a Spectacular Solo rendition of Michael Buble's "Feeling Good". His victory was celebrated nationwide, with fans and supporters praising his authenticity and musical brilliance. </p>

      </div>
      
      
      </div>
  );
};
